import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import {
    Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import { Tooltip } from '@mui/material';
import Select from 'react-select';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchDataActive, fetchData, fetchData1, postData, updateData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

//import '../../styles.css';
function AccountIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteManufacture, setDeleteManufacture] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    //const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, clubId, userId, branchId, permissions, logout, token } = useAuth();
    const [successMessage, setSuccessMessage] = useState("");
    //Create Constants---------------------
    const [isSubmit, setIsSubmit] = useState(false);
    const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
    const [head, setAccountHead] = useState("");
    const [currency, setCurrency] = useState("INR");
    const [parent, setParent] = useState();
    const [feesamount, setFeesAmount] = useState("");
    //const [nature, setNature] = useState("1");
    const [natureLabel, setNatureLabel] = useState('');
    const [selectedfreequency, setSelectedFrequency] = useState(0);
    const [selectedpolarity, setSelectedPolarity] = useState(null); // Initialize to null
    const optionsp = [
        { value: 1, label: 'Dr' },
        { value: 2, label: 'Cr' },
    ];
    const [natureOptions, setNatureOptions] = useState([]);
    const [nature, setNature] = useState();
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    // const optionsn = [
    //     { value: 1, label: 'Income' },
    //     { value: 2, label: 'Expenditure' },
    //     { value: 3, label: 'Long Term Liabilities' },
    //     { value: 4, label: 'Current Liabilities' },
    //     { value: 5, label: 'Fixed Asset' },
    //     { value: 6, label: 'Current Asset' },
    //     { value: 7, label: 'Capital' },

    // ];


    const [opening, setOpening] = useState(0);
    const [openingdate, setOpeningDate] = useState("");
    const [isincome, setIncome] = useState(false);
    const [isExpense, setExpense] = useState(true);
    const [isEvent, setEvent] = useState(false);
    const [isFees, setFees] = useState(false);
    const [isMeetingExpense, setMeetingExpense] = useState(false);
    const [selectedValue, setSelectedValue] = useState(1);
    //-------------------------------------------for edit-------------------
    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false); // For editing
    const [isEditing, setIsEditing] = useState(false);

    const [editData, setEditData] = useState({
        head: null,
        natureId: null,
        openingBalancePolarityId: null

    });
    const [selectedNature, setSelectedNature] = useState(null); // New state for react-select value
    const [parentGroupOptions, setParentGroupOptions] = useState([]);
    const [feesoptions, setFeesOptions] = useState([]);
    const [selectedfees, setselectedfees] = useState("");
    const [selectedgroup, setselectedgroup] = useState("");


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
        //fetchParentData();
        fetchNatureData();
        fetchFeesData();
        //inputRef.current.focus();
    }, [isAuthenticated, clubId, branchId, token, logout]);

    useEffect(() => {
        if (editData.natureId) {
            const selectedOptionNature = natureOptions.find(option => option.value === editData.natureId);
            setSelectedNature(selectedOptionNature || null);
            // setSelectedNature(selectedOptionNature || null);
            // setParent(parentGroupOptions.label);
        }
        if (editData.balanceSheetOrPandLHeadId) {
            const selectedOptionBalancesheethead = parentGroupOptions.find(option => option.value === editData.balanceSheetOrPandLHeadId);
            setselectedgroup(selectedOptionBalancesheethead || null);
        }
        if (editData.openingBalancePolarityId) {
            const selectedOptionPolarity = optionsp.find(option => option.value === editData.openingBalancePolarityId);
            setSelectedPolarity(selectedOptionPolarity || null);
        }
    }, [editData, natureOptions, optionsp]); // Add optionsp to dependency array




    const fetchParentGroups = async (natureId) => {
        try {
            const response = await fetchData('ParentGroupApi', `/${clubId}/${branchId}/${natureId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map((group) => ({
                    value: group.Id,
                    label: group.Head,
                }));

                //  setselectedgroup(options); // Clear previous selection (optional)
                if (options.length > 0) {
                    setParent(options[0].label);
                    setselectedgroup(options[0]);
                    setEditData(
                        (prevData) => ({
                            ...prevData,
                            balanceSheetOrPandLHeadId: options[0].value,
                            balanceSheetOrPandLHead: options[0].label, 
                        })
                    )
                }
            } else {
                console.warn('No parent groups found for selected nature.');
                setParentGroupOptions([]);
            }
        } catch (error) {
            console.error('Error fetching parent group data:', error);
            setParentGroupOptions([]);
        }
    };
    const fetchNatureData = async () => {
        fetchData('NatureApi', `/${clubId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {

                    const options = response.response_data.map(group => ({
                        value: group.Id,
                        label: group.Name
                    }));
                    setNatureOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching Nature Details:', error);
            });
    };

    const fetchFeesData = async () => {

        fetchData1('ClubFeesApi', `/tmpType/${clubId}/${branchId}/${1}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {

                    const options = response.response_data.map(group => ({
                        value: group.id,
                        label: group.feesDescription

                    }));
                    setFeesOptions(options);
                    //setFilteredData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Persons Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };


    const fetchtableData = async () => {
        fetchData('AccountHeadApi', `/${clubId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    // setFilteredData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching AccountHead Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const handleDelete = async () => {
        deleteData('AccountHeadApi', `${deleteManufacture}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteManufacture(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (manuId) => {
        activateData('AccountHeadApi', `${manuId}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (manuId) => {
        setDeleteManufacture(manuId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteManufacture(null);
        setConfirmDialogOpen(false);
    };


    //Create Section----------------------
    const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        submitData(e);

    }


    const submitData = async (e) => {
        e.preventDefault();


        // Validation
        if (head === "" || opening === undefined || opening === null) {
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            return;
        }
        const accountheads = {
            Head: head,
            Currency: currency,
            NatureId: nature.value,
            BalanceSheetOrPandLHeadId: selectedgroup.value,
            BalanceSheetOrPandLHead: selectedgroup.label,
            Nature: nature.label,
            OpeningBalancePolarity: !isFees ? selectedpolarity?.label || null : null,
            OpeningBalancePolarityId: !isFees ? selectedpolarity?.value || null : null,
            OpeningBalanceDate: !isFees ? openingdate || null : null,
            OpeningBalanceAmt: !isFees ? opening || null : null,
            IsExpense: isExpense, // Set FromDate to null if One Time
            IsMeetingExpense: isMeetingExpense,     // Set ToDate to null if One Time
            CreatedBy: userId || "",
            CreatedDate: new Date(),
            ClubId: clubId || "",
            BranchId: branchId || "",
            IsEvent: isEvent,
            FeesId: selectedfees.value,
            IsFees: isFees,
            FeesAmount: feesamount || null,
            FeesRecuringType: null || selectedfreequency, // Set ToDate to null if One Time
            FromDate: fromDate || null,
            ToDate: toDate || null,

        };

        try {
            const response = await postData('AccountHeadApi', accountheads, token);
            console.log('Account Head Created successfully:', response);
            setSuccessMessage("Account Head Created successfully!");
            setErrorMessage("");

            resetForm(); // Ensure this function resets all relevant state variables
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
            window.location.reload();
        } catch (error) {
            console.error('Account Head Create error:', error);
            setErrorMessage("Error creating Account Head. Please try again.");
        }
        setIsModalOpenCreate(false);
    };



    const toggleModalCreate = () => {
        setIsModalOpenCreate(prev => !prev);
        setEvent(false);
        setFees(false) // Reset event state when toggling modal

    };
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };


    const handleInputChange = (event) => {
        const { name, value, type } = event.target;
        setEditData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    //Edit-------------------------

    const toggleModalEdit = () => {
        setIsModalOpenEdit(prev => {
            const nextState = !prev; // Calculate the NEXT state
            if (!nextState) { // Check the NEXT state (after the toggle)
                resetForm();
                setEditData({}); // Or setEditData(initialEditData) if you have an initial state
                setIsEditing(false);
            }
            return nextState; // Return the new state to update isModalOpenEdit
        });
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
    };
    // Reset form fields
    const resetForm = () => {
        setAccountHead('');
        setOpening('');
        setIncome(false);
        setExpense(true);
        setMeetingExpense(false)
    };
    const handleChange1 = (selectedOption) => {
        setNature(selectedOption); // Get selected value
        if (selectedOption && selectedOption.value) { fetchParentGroups(selectedOption.value); }

    };
    const handleChange3 = (selectedOption) => { // Correctly receive selectedOption
        setSelectedNature(selectedOption);
        setEditData({ ...editData, natureId: selectedOption ? selectedOption.value : null }); // Update editData
        if (selectedOption && selectedOption.value) { fetchParentGroups(selectedOption.value); }
    };
    const handleChange4 = (selectedOption) => { // Correctly receive selectedOption
        setSelectedPolarity(selectedOption);
        setEditData({ ...editData, openingBalancePolarityId: selectedOption ? selectedOption.value : null }); // Update editData
    };

    // const handleChange2 = (event) => {
    //     setPolarity(event.target.value); // Get selected value

    // };

    const handleChange2 = (event) => {
        setSelectedPolarity(event)
    };

    const handleEdit = (id) => {
        fetchData('AccountHeadApi', `/AccountHeadApi/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const data = response.response_data;
                    setEditData(data); // Store fetched data in state
                    setIsEditing(true); // Set editing mode
                    toggleModalEdit(); // Open the modal
                    // Convert date to YYYY-MM-DD format
                    const formattedDate = data.openingBalanceDate ? new Date(data.openingBalanceDate).toISOString().split('T')[0] : '';
                    setOpeningDate(formattedDate);
                    // const parentGroup = {
                    //     label: data.balanceSheetOrPandLHead,
                    //     value: data.balanceSheetOrPandLHeadId,
                    // };
                    // setselectedgroup(data.balanceSheetOrPandLHead);

                } else {
                    console.error('Error fetching Account Head details');
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const handleFormSubmitEdit = async (e) => {
        e.preventDefault(); // Prevent default form submission

        if (isEditing && editData) {
            const accountheads = {
                Id: editData.id,
                Head: editData.head || null,
                Currency: editData.currency || null,
                NatureId: nature?.value ?? editData.natureId,
                Nature: nature?.label ?? editData.nature,
                BalanceSheetOrPandLHeadId: selectedgroup?.value ?? editData.balanceSheetOrPandLHeadId,
                BalanceSheetOrPandLHead: selectedgroup?.label ?? editData.balanceSheetOrPandLHead,
                OpeningBalancePolarity: selectedpolarity?.label ?? (editData?.OpeningBalancePolarity ?? null),
                OpeningBalancePolarityId: selectedpolarity?.value ?? (editData.openingBalancePolarityId ?? null),
                OpeningBalanceDate: editData.openingBalanceDate || null,
                OpeningBalanceAmt: editData.openingBalanceAmt || null,
                IsExpense: editData.isExpense, // Set FromDate to null if One Time
                IsMeetingExpense: editData.isMeetingExpense,
                IsEvent: editData.isEvent,
                UpdatedBy: userId || "",
                UpdatedDate: new Date(),
                ClubId: clubId || "",
                IsFees: editData.isFees,
                FeesId: 0,
                FeesAmount: parseFloat(feesamount ?? (editData.feesAmount ?? 0)) || null,
                FeesRecuringType: selectedfreequency ?? editData.selectedfreequency, // Set ToDate to null if One Time
                FromDate: fromDate || editData.fromDate || null,
                ToDate: toDate || editData.toDate || null,
            };

            try {
                const response = await updateData('AccountHeadApi', editData.id, accountheads, token);
                console.log('Record updated successfully:', response);
                setSuccessMessage("Record updated successfully!");
                toggleModalEdit(); // Close the modal
                setTimeout(() => {
                    setSuccessMessage(""); // Clear success message after a delay
                }, 3000);
                fetchtableData(); // Refresh the table data
            } catch (error) {
                console.error('Error updating record:', error);
            }
        }
    };


    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('PurchaseOrderDate');


    const handleParentGroupChange = (selectedOption) => {
        setselectedgroup(selectedOption); // Store the whole object
        setEditData({ ...editData, balanceSheetOrPandLHeadId: selectedOption ? selectedOption.value : null }); // Update editData

    };
    const handleFeesChange = (selectedOption) => {
        setselectedfees(selectedOption); // Store the whole object

    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };




    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page when changing rows per page
    };

    const handleChangePolarity = (event) => {
        setSelectedFrequency(event.target.value); // Get selected value
    };
    const sortedData = stableSort(filteredData, getComparator(order, orderBy));
    const commonButtonStyles = {
        height: '36px',
        marginLeft: '10px',
        marginTop: '1.00%',
        marginRight: '8px',
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>

                {/* <h6 className='productHead flex-grow linkcolor'
                    style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    ACCOUNT REGISTRATION</h6>


                <div className="button-container-1">

                    <Button
                        component={Link}
                        onClick={toggleModalCreate}
                        className="linkcolor"
                        style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#347928', height: '25px' }}
                    >
                        <AddIcon /> CREATE
                    </Button>
                </div> */}

                <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}> ACCOUNT REGISTRATION</h6>

                <input
                    className="shadow text-gray-700 leading-tight"
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? '250px' : '140px',
                        height: '30px',
                        border: '1px solid #ccc',
                        borderRadius: '15px',
                        padding: '0 20px',
                        transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                        outline: 'none',
                        borderColor: isFocused ? 'darkcyan' : '#ccc',
                        boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        marginLeft: '10px'
                    }}
                />

                <div className="button-container-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Tooltip
                        title="Create ACCOUNT REGISTRATION"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#0e728c',
                                    color: 'white',
                                    border: '1px solid white',
                                    fontWeight: 'bold',
                                    boxShadow: 2,
                                },
                            },
                        }}
                    >
                        <Button
                            component={Link}
                            onClick={toggleModalCreate}
                            className="linkcolor"
                            style={{ color: 'whitesmoke', fontsize: '11px', backgroundColor: '#27391C', height: '25px', marginLeft: '5px' }}
                        >
                            CREATE
                        </Button>
                    </Tooltip>
                </div>
            </div>


            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        {/* <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}> */}

                        <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>

                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Sl No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Account Head</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Opening</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textAlign: 'right', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                            {paginatedData.map((head, index) => (

                                <TableRow
                                    key={head.id}
                                    className={head.isActive ? '' : 'inactiveRow'}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd', // Alternate row background colors
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px' }}>{head.head}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px' }}>
                                        {head.opening != null ? head.opening.toFixed(2) : '-'}
                                    </TableCell>


                                    <TableCell sx={{ padding: '2px', textAlign: 'right' }}>
                                        <Link to="#" onClick={() => handleEdit(head.id)}>
                                            <Tooltip title="Edit Account head">
                                                <IconButton>
                                                    <EditIcon style={{ fontsize: '20px', color: 'blue' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>
                                        <Tooltip title="Delete Account head">
                                            <IconButton onClick={() => (head.isActive ? openConfirmDialog(head.id) : handleActivate(head.id))}>
                                                {head.isActive ? <DeleteIcon style={{ fontsize: '20px', color: 'brown' }} /> : <ActivateIcon style={{ fontsize: '20px' }} />}
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            '& .MuiTablePagination-toolbar': {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'nowrap', // Ensures everything stays in one line
                                minHeight: '40px', // Keeps a proper height
                            },
                            '& .MuiTablePagination-selectLabel': {
                                marginBottom: 0, // Fixes label misalignment
                            },
                            '& .MuiTablePagination-displayedRows': {
                                marginBottom: 0, // Fixes row count misalignment
                            },
                        }}
                    />

                </TableContainer>
            </div>


            {isModalOpenCreate && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '80%' }}>
                        <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', textAlign: 'center' }}>CREATE ACCOUNT HEAD </h6>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/10 mr-2">
                                <div className="flex items-right">
                                    <input
                                        type="checkbox"
                                        id="isEvent"
                                        name="entityType"
                                        value="isEvent"
                                        checked={isEvent}
                                        onChange={() => {
                                            const newValue = !isEvent; // Toggle value
                                            setEvent(newValue);
                                            setFees(false);
                                            if (newValue) {
                                                setIncome(false);
                                                setExpense(true);
                                                setMeetingExpense(false); // Reset meeting expense when switching to expense
                                            }
                                        }}
                                    />
                                    <label htmlFor="isEvent" className="ml-2">Event</label>
                                </div>
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="isEvent"
                                        name="entityType"
                                        value="isEvent"
                                        checked={isFees}
                                        onChange={() => {
                                            const newValue = !isFees; // Toggle value
                                            setFees(newValue);
                                            setEvent(false);

                                            if (newValue) {
                                                setIncome(false);
                                                setExpense(true);
                                                setMeetingExpense(false); // Reset meeting expense when switching to expense
                                            }
                                        }}
                                    />
                                    <label htmlFor="isEvent" className="ml-2">Fees</label>
                                </div>



                            </div>
                        </div>

                        <div className="w-full mb-4 flex">

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="feesDescription">Account Head</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={head}
                                    onChange={(e) => setAccountHead(e.target.value)}
                                    type="text"
                                    placeholder="Enter Account Head"
                                />
                            </div>
                            <div className="w-1/6 mr-2">


                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Currency"> Currency</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={currency}
                                    onChange={(e) => setCurrency(e.target.value)}
                                    type="text"
                                    placeholder="Enter Currency"
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="parentgroup">Nature</label>
                                <Select
                                    options={natureOptions}
                                    value={nature}
                                    onChange={handleChange1}
                                    isSearchable
                                    menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (provided) => ({
                                            ...provided,
                                            width: "100%",
                                            minWidth: 0, // allow shrinking
                                            whiteSpace: "nowrap"
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: "100%",
                                            minWidth: "200px",
                                            whiteSpace: "nowrap",
                                            overflowX: "auto", // Allows horizontal scrolling if needed
                                            overflowY: "hidden", // Disables vertical scrolling
                                            maxHeight: "none"
                                        }),

                                    }}
                                />
                            </div>
                            {/*} <div className="w-1/4">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="parentgroup">Balace Sheet / P & L Heads</label>
                                <Select
                                    value={selectedgroup}
                                    onChange={handleParentGroupChange}
                                    options={parentGroupOptions}
                                    placeholder="Parent Grp"
                                    isSearchable
                                    menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (provided) => ({
                                            ...provided,
                                            width: "260px", // Default fixed width
                                            minWidth: "200px", // Prevents shrinking smaller than this
                                            maxWidth: "auto", // Expands if needed
                                            whiteSpace: "nowrap"
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: "auto",
                                            minWidth: "260px",
                                            whiteSpace: "nowrap",
                                            overflowX: "auto", // Allows horizontal scrolling if needed
                                            overflowY: "hidden", // Disables vertical scrolling
                                            maxHeight: "none"
                                        }),

                                    }}
                                />
                            </div>*/}

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Currency"> Parent Group</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={parent}
                                    //onChange={(e) => setParent(e.target.value)}
                                    type="text"
                                    placeholder="Parent Group"
                                />
                            </div>

                        </div>
                        {!isFees && (

                            <div className="w-full mb-4 flex">

                                <div className="w-1/2 mr-2">

                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Bal Amt</label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                        value={opening}
                                        onChange={(e) => setOpening(e.target.value)}
                                        type="text"
                                        placeholder="Enter Opening"
                                    />
                                </div>
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Bal Polarity</label>

                                    <Select
                                        options={optionsp}
                                        value={selectedpolarity} // Important: Bind the value
                                        onChange={handleChange2}
                                    />
                                </div>
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Bal Date</label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                        value={openingdate}
                                        onChange={(e) => setOpeningDate(e.target.value)}
                                        type="date"
                                        placeholder="Select Date"
                                    />
                                </div>
                            </div>
                        )}
                        <div className="w-full mb-4 flex">

                            {isFees && (
                                <>
                                    <div className="w-1/4 mr-2">
                                        <label htmlFor="feesDescription">Select Frequency</label>
                                        <select
                                            name="selectedfreequency"
                                            value={selectedfreequency}
                                            onChange={handleChangePolarity}
                                            className="form-select block w-full ml-4"
                                        >

                                            <option value="0">One Time</option>
                                            <option value="1">Monthly</option>
                                            <option value="2">Quarterly</option>
                                            <option value="3">Half Yearly</option>
                                            <option value="4">Yearly</option>
                                        </select>
                                    </div>


                                    <div className="w-1/8 mr-2">
                                        <label htmlFor="feesAmount">Fees Amount</label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={feesamount}
                                            onChange={(e) => setFeesAmount(e.target.value)}
                                            type="text"
                                            placeholder="Enter Fees Amount"
                                        />
                                    </div>
                                </>
                            )}



                            {(isFees && selectedfreequency != 0 &&
                                <>
                                    <div className="w-1/4 mr-2">


                                        <label htmlFor="fromDate">From Date</label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={fromDate}
                                            onChange={(e) => setFromDate(e.target.value)}
                                            type="date"
                                            placeholder="From Date"
                                        />
                                    </div>
                                    <div className="w-1/4 mr-2">
                                        <label htmlFor="toDate">To Date</label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={toDate}
                                            onChange={(e) => setToDate(e.target.value)}
                                            type="date"

                                        />
                                    </div>
                                </>

                            )}
                        </div>




                        {/* Action Buttons */}
                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            <Button onClick={handleFormSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#5DB996' }}>
                                Save
                            </Button>
                            <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#FF748B', marginLeft: '5px' }} onClick={toggleModalCreate}>
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            )}



            {isModalOpenEdit && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '80%' }}>
                        <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>EDIT ACCOUNT ENTRY</h6>

                        {/* Radio Buttons for selecting Income or Expense */}
                        <div className="w-full mb-4 flex">
                            <div className="w-1/10 mr-2">
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="isEvent"
                                        name="isEvent"
                                        value="isEvent"
                                        checked={editData.isEvent}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="isEvent" className="ml-2">Event</label>
                                </div>
                            </div>
                        </div>


                        <div className="w-full mb-4 flex">
                            <div className="w-1/10 mr-2">
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="isFees"
                                        name="isFees"
                                        value="isFees"
                                        checked={editData.isFees}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="isFees" className="ml-2">Fees</label>
                                </div>
                            </div>
                        </div>
                        {/* Account Head and Opening Fields */}
                        <div className="w-full mb-4 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="head">Account Head</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    name="head"
                                    value={editData.head}
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="Enter Account Head"
                                />
                            </div>
                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="feesDescription">Currency</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    name="currency"
                                    value={editData.currency}
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="Enter Currency"
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="nature">Nature</label>
                                <Select
                                    options={natureOptions}
                                    value={selectedNature}
                                    onChange={handleChange3}
                                    isSearchable
                                    menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (provided) => ({
                                            ...provided,
                                            width: "100%",
                                            minWidth: 0, // allow shrinking
                                            whiteSpace: "nowrap"
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: "auto",
                                            minWidth: "200px",
                                            whiteSpace: "nowrap",
                                            overflowX: "auto", // Allows horizontal scrolling if needed
                                            overflowY: "hidden", // Disables vertical scrolling
                                            maxHeight: "none"
                                        }),

                                    }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Currency"> Parent Group</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={editData.balanceSheetOrPandLHead}
                                    type="text"
                                    placeholder="Parent Group"
                                />
                            </div>


                        </div>




                        {(!editData.isFees) && (
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">

                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Balance Amount</label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                        name="openingBalanceAmt"
                                        value={editData.openingBalanceAmt}
                                        //onChange={(e) => setOpening(e.target.value)}
                                        type="text"
                                        onChange={handleInputChange}
                                        placeholder="Enter Opening"
                                    />
                                </div>
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Balance Polarity</label>
                                    <Select
                                        options={optionsp}
                                        value={selectedpolarity}  // Use selectedNature for the Select value
                                        onChange={handleChange4}
                                    //isClearable={true} //Make it clearable
                                    />

                                </div>
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Balance Date</label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                        name="openingBalanceDate"
                                        value={formatDateForInput(editData.openingBalanceDate)}
                                        onChange={handleInputChange}
                                        type="date"
                                        placeholder="Select Date"
                                    />
                                </div>
                            </div>
                        )}

                        <div className="w-full mb-4 flex">

                            {(isFees || editData.isFees) && (
                                <>
                                    <div className="w-1/2 mr-6">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="feesDescription">Select Frequency</label>
                                        <select
                                            name="selectedfreequency"
                                            value={selectedfreequency}
                                            onChange={handleChangePolarity}
                                            className="form-select block w-1/2 ml-4"
                                        >
                                            <option value="0">One Time</option>
                                            <option value="1">Monthly</option>
                                            <option value="2">Quarterly</option>
                                            <option value="3">Half Yearly</option>
                                            <option value="4">Yearly</option>
                                        </select>
                                    </div>
                                    <div className="w-1/2 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="feesAmount">Fees Amount</label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={editData.feesAmount}
                                            type="text"
                                            onChange={handleInputChange}
                                            placeholder="Enter Fees Amount"
                                        />
                                    </div>
                                </>
                            )}

                            {(isFees || editData.isFees) && (selectedfreequency != 0 &&
                                <>
                                    <div className="w-1/4 mr-2">

                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate">From Date</label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            name="fromDate"
                                            value={formatDateForInput(editData.fromDate)}
                                            onChange={handleInputChange}
                                            type="date"

                                        />
                                    </div>
                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="toDate">To Date</label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            name="toDate"
                                            value={formatDateForInput(editData.toDate)}
                                            onChange={handleInputChange}
                                            type="date"

                                        />
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Action Buttons */}
                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            <Button onClick={handleFormSubmitEdit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#5DB996' }}>
                                Update
                            </Button>
                            <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#FF748B', marginLeft: '5px' }} onClick={toggleModalEdit}>
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    );

}


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export default AccountIndex;




